module.exports = __webpack_public_path__ + "static/img/news2.5c250fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news3/news2.jpg
// module id = E1y8
// module chunks = 1